import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export default function AboutCTA() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Juicy%20gourmet%20burger%20with%20melted%20cheese%20dripping%20beef%20patty%20sesame%20bun%20dark%20dramatic%20studio%20lighting%20orange%20warm%20glow%20bokeh%20background%20appetizing%20food%20photography%20cinematic%20close%20up%20Colombian%20style&width=1920&height=800&seq=about-cta1&orientation=landscape"
          alt="Bucara Burger menu Boise Idaho"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/85"></div>
        {/* Orange glow */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#F57F25]/10 via-transparent to-[#F57F25]/10"></div>
      </div>

      {/* Decorative top line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#F57F25] to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-10 h-0.5 bg-[#F57F25]"></div>
          <span className="text-[#F57F25] text-xs font-bold tracking-widest uppercase">{t('about_cta_eyebrow')}</span>
          <div className="w-10 h-0.5 bg-[#F57F25]"></div>
        </div>

        <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-white uppercase leading-tight mb-6">
          {t('about_cta_title')}<br />
          <span className="text-[#F57F25]">{t('about_cta_title_accent')}</span>
        </h2>

        <p className="text-white/60 text-lg md:text-xl leading-relaxed mb-12 max-w-2xl mx-auto">
          {t('about_cta_sub')}
        </p>

        {/* Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={() => navigate('/menu')}
            className="bg-[#F57F25] hover:bg-[#e06d15] text-black font-black text-base px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap hover:scale-105"
          >
            {t('btn_view_menu')}
          </button>
          <a
            href="https://wa.me/19862173604?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order."
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 border-2 border-white/40 hover:border-[#F57F25] text-white hover:text-[#F57F25] font-black text-base px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            {t('btn_order_whatsapp')}
          </a>
          <a
            href="tel:+19862173604"
            className="flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-black text-base px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line text-lg"></i>
            {t('btn_call_now')}
          </a>
        </div>
      </div>

      {/* Decorative bottom line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#F57F25] to-transparent"></div>
    </section>
  );
}
